import { computed, type ComputedRef } from 'vue';
import { Cookie } from '@vue-util/cookie';
import { cookies } from 'config';
import { getBigTicketZipCookie } from '~/utils/cookiesUtils';
import { getStoreLocation } from '~/modules/availability/utils/localStorage';
import useAvailabilityBigTicketStore from '~/stores/useAvailabilityBigTicketStore';

export type BigTicketZipCodeReturnData = {
  zipCode: ComputedRef<string>;
  setZipCode: () => void;
};

/**
 * Big Ticket zip code state and cookie synchronization.
 * Consumed directly inside useAvailabilityBigTicketProvide.
 */
export const useBigTicketZipCode = (): BigTicketZipCodeReturnData => {
  const store = useAvailabilityBigTicketStore();
  const zipCode = computed(() => store.zipCode);

  const setZipCode = () => {
    const zipCodeFromCookie = getBigTicketZipCookie();
    const storeLocationZipCode = getStoreLocation()?.zipcode;
    const resolvedZip = zipCodeFromCookie || storeLocationZipCode;

    store.setZip(resolvedZip);

    if (zipCodeFromCookie) {
      return;
    }

    const isValidZipCode = (zip: string) => /^\d{5}$/.test(zip);
    if (storeLocationZipCode && isValidZipCode(storeLocationZipCode)) {
      Cookie.set(cookies.bigTicketZipCode, storeLocationZipCode, cookies.miscGCs);
    }
  };

  return {
    zipCode,
    setZipCode,
  };
};
